import React, { useEffect, useState } from "react";
import { callMultipleApis } from "../../services/ApiServices";
import './VisitCounter.css';

const getVisitCounterURL = process.env.REACT_APP_GET_VISIT_COUNT_URL;

const VisitCounter = () => {
  const [visits, setVisits] = useState(null);

  useEffect(() => {
    fetchVisitCount();
  }, []);

  async function fetchVisitCount() {
    try {
      const [resVisitCount] = await callMultipleApis([
        {
          url: getVisitCounterURL,
          method: "POST",
          data: {},
          params: {},
          headers: {},
        }
      ]);
      setVisits(resVisitCount.result);
    } catch (error) {
    } finally {
    }
  }

  return (
    <div className="visit-container">
      {visits !== null ? (
        <p className="visit-text">
          Visitor No: <span className="visit-number">{visits}</span>
        </p>
      ) : (
        <p className="visit-loading">Loading visit count...</p>
      )}
    </div>
  );
};

export default VisitCounter;
